module.exports = __webpack_public_path__ + "img/464543_D1CFC1_8E8C83_A4AC9C-256px.618944b4.png";